export const noop = () => {};
export const identity = <T>(value: T): T => value;
export const returnTrue = () => true;
export const returnFalse = () => false;
